<div class="card" *ngIf="!resetSuccessful">
  <div class="card-body">
    <app-form-field-password
      [field]="passwordControl"
      label="label.password"></app-form-field-password>
    <app-form-field-password
      [field]="passwordRepeatControl"
      label="label.passwordRepeat"></app-form-field-password>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button (click)="submit()" class="btn btn-primary">{{'button.save'|translate}}</button>
  </div>
</div>
<div class="card" *ngIf="resetSuccessful">
  <div class="card-body">
    <div class="d-flex">
      <div class="flex-1">{{'message.reset-password-successful'|translate}}</div>
      <button class="btn btn-primary"
              [routerLink]="['/landing']"
      >{{'button.to-login'|translate}}</button>
    </div>
  </div>
</div>
